<template>
  <div>
    <!-- MAIN -->
    <div class="breadcrumbs ace-save-state" id="breadcrumbs">
      <ul class="breadcrumb">
        <li>
          <i class="ace-icon fa fa-home home-icon"></i>
          <a href="#/">ダッシュボード</a>
        </li>
        <li class="active">ログ情報</li>
      </ul><!-- /.breadcrumb -->
    </div>
    <!-- END MAIN -->
    <div class="page-content" style="padding-top:200px">
      <div id="loading" v-if="loading"><div class="loadingMsg"></div></div>
      <div class="row">
        <div class="col-xs-12">
          <div class="tabbable">
            <div class="alert alert-danger" v-if="errorMessageLogs!==''">
              {{ errorMessageLogs }}
            </div>
            <ul class="nav nav-tabs padding-12 tab-color-blue background-blue" id="myTab4">
              <li class="active">
                <a data-toggle="tab" href="#log-gate" aria-expanded="true" @click="loadLog()">照合ログ</a>
              </li>
              <li v-if="isAdmin === 'true'" style="display:none">
                <a data-toggle="tab" href="#log-owner" aria-expanded="false" @click="loadOwnLog()">操作ログ</a>
              </li>
            </ul>
            <div class="tab-content">
              <div id="log-gate" class="tab-pane active">
                <div class="page-header">
                  <div class="checkbox">
                    <span style="float:left;padding:5px!important;margin-left:5px">
                      <div class="row">
                      <label class="checkbox-box">
                        <input name="form-field-checkbox" type="checkbox" class="ace" @click="setTimelogGate()">
                        <span class="lbl">期間指定</span>
                      </label>
                      </div>
                    </span>
                    <div class="col-sm-2">
                      <div class="row">
                        <div class="input-group date-picker">
                          <input class="form-control date-picker-notbefore" :disabled="!flaglogGate" id="notBefore" type="text" data-date-format="yyyy/mm/dd" />
                          <span class="input-group-addon icon_date_notbefore">
                            <i class="fa fa-calendar bigger-110"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="row">
                        <div class="input-group bootstrap-timepicker">
                          <input id="notBefore-time" type="text" :disabled="!flaglogGate" class="form-control" />
                          <span class="input-group-addon">
                            <i class="fa fa-clock-o bigger-110"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <span style="float:left;padding:5px!important">~</span>
                    <div class="col-sm-2">
                      <div class="row">
                        <div class="input-group date-picker">
                          <input class="form-control date-picker-notafter" :disabled="!flaglogGate" id="notAfter" type="text" data-date-format="yyyy/mm/dd" />
                          <span class="input-group-addon icon_date_notafter">
                            <i class="fa fa-calendar bigger-110"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="row">
                        <div class="input-group bootstrap-timepicker">
                          <input id="notAfter-time" type="text" :disabled="!flaglogGate" class="form-control" />
                          <span class="input-group-addon">
                            <i class="fa fa-clock-o bigger-110"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style="clear:both"></div>
                  </div>
                  <div class="checkbox">
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox" type="checkbox" class="ace userId" checked @click="addRomoveScorpLogGate('userId', 'userId')">
                      <span class="lbl">ユーザーID</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" class="userName ace" checked @click="addRomoveScorpLogGate('userName', 'userName')">
                      <span class="lbl">ユーザー名</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" class="userFurigana ace" checked @click="addRomoveScorpLogGate('userFurigana', 'userFurigana')">
                      <span class="lbl">ユーザー名ふりがな</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" class="gateId ace" checked @click="addRomoveScorpLogGate('gateId', 'gateId')">
                      <span class="lbl">ゲートID</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" class="gateName ace" checked @click="addRomoveScorpLogGate('gateName', 'gateName')">
                      <span class="lbl">ゲート名</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" class="deviceId ace" checked @click="addRomoveScorpLogGate('deviceId', 'deviceId')">
                      <span class="lbl">照合機器ID</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" class="deviceType ace" checked @click="addRomoveScorpLogGate('deviceType', 'deviceType')">
                      <span class="lbl">照合機器タイプ</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" class="logLabel ace" checked @click="addRomoveScorpLogGate('logLabel', 'logLabel')">
                      <span class="lbl">ログ名称</span>
                    </label>
                  </div>
                  <span class="input-icon search-box">
                    <input type="text" placeholder="選択項目にチェックして検索" class="nav-search-input" id="nav-search-input" autocomplete="off">
                    <i class="ace-icon fa fa-search nav-search-icon"></i>
                  </span>
                  <button class="btn-cusstom green-btn" type="button" @click="search()">検索</button>
                  <a class="btn-cusstom green-btn export-btn pull-right" href="#process" data-toggle="modal" @click="exportDataExe('logs')">CSVファイルをエクスポート</a>
                  <div style="clear:both"></div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div class="pull-right">
                      <a class="option_button collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseOne" aria-expanded="false">表示オプション&nbsp;
                        <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
                      </a>
                    </div>
                    <div class="clearfix" style="clear:both">
                      <div id="accordion">
                        <div class="panel-collapse collapse" id="collapseOne" aria-expanded="false" style="height: 0px;">
                          <div class="panel-body">
                            <div class="control-group">
                              <label class="control-label bolder blue display_block">表示項目</label>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_time" type="checkbox" class="ace" disabled checked>
                                  <span class="lbl">時間</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_user_id" type="checkbox" class="ace" @click="ShowHideColumn" checked value="userId" v-model="checkedColumnNames">
                                  <span class="lbl">ユーザーID</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_user_name" type="checkbox" class="ace" @click="ShowHideColumn" checked value="userName" v-model="checkedColumnNames">
                                  <span class="lbl">ユーザー名</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_user_furigana" type="checkbox" class="ace" @click="ShowHideColumn" value="userFurigana" v-model="checkedColumnNames">
                                  <span class="lbl">ユーザー名ふりがな</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_gate_id" type="checkbox" class="ace" @click="ShowHideColumn" checked value="gateId" v-model="checkedColumnNames">
                                  <span class="lbl">ゲートID</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_gate_name" type="checkbox" class="ace" @click="ShowHideColumn" checked value="gateName" v-model="checkedColumnNames">
                                  <span class="lbl">ゲート名</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_device_id" type="checkbox" class="ace" @click="ShowHideColumn" checked value="deviceId" v-model="checkedColumnNames">
                                  <span class="lbl">照合機器ID</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_device_type" type="checkbox" class="ace" @click="ShowHideColumn" value="deviceType" v-model="checkedColumnNames">
                                  <span class="lbl">照合機器タイプ</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_log_id" type="checkbox" class="ace" @click="ShowHideColumn" value="accessLogId" v-model="checkedColumnNames">
                                  <span class="lbl">ログID</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_label" type="checkbox" class="ace" @click="ShowHideColumn" checked value="logLabel" v-model="checkedColumnNames">
                                  <span class="lbl">ログ名称</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_sequenceNo" type="checkbox" class="ace" @click="ShowHideColumn" value="sequenceNo" v-model="checkedColumnNames">
                                  <span class="lbl">ゲートログNo</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_gate_voltage" type="checkbox" class="ace" @click="ShowHideColumn" checked value="voltage" v-model="checkedColumnNames">
                                  <span class="lbl">電池電圧</span>
                                </label>
                              </div>
                            </div>
                            <div class="control-group">
                              <label class="control-label bolder blue display_block">ページことに表示する項目</label>
                              <select id="pageSizeOptions" class="first-child last-child" @change="handleSizeChange" v-model="selected">
                                <option v-for="pageSize in pageSizeOptions" v-bind:value="pageSize" v-bind:key="pageSize">
                                {{ pageSize }} 件
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <table id="simple-table" class="table  table-bordered table-hover dataTable" v-if="list.length > 0">
                      <thead>
                        <tr>
                          <th class="center" style="display:none">
                            <label class="pos-rel">
                              <input type="checkbox" class="ace" v-model="selectAllGateLog">
                              <span class="lbl"></span>
                            </label>
                          </th>
                          <th id="log_gate_time" class="log_gate_time sorting" @click="sort('timestamp', 'log_gate_time')">時間</th>
                          <th id="log_gate_user_id" class="log_gate_user_id sorting" @click="sort('userId', 'log_gate_user_id')" v-bind:class="{'none': checkColumnShowHide('userId')}">ユーザーID</th>
                          <th id="log_gate_user_name" class="log_gate_user_name sorting" @click="sort('userName', 'log_gate_user_name')" v-bind:class="{'none': checkColumnShowHide('userName')}">ユーザー名</th>
                          <th id="log_gate_user_furigana" class="log_gate_user_furigana sorting" @click="sort('userFurigana', 'log_gate_user_furigana')" v-bind:class="{'none': checkColumnShowHide('userFurigana')}">ユーザー名ふりがな</th>
                          <th id="log_gate_gate_id" class="log_gate_gate_id sorting" @click="sort('gateId', 'log_gate_gate_id')" v-bind:class="{'none': checkColumnShowHide('gateId')}">ゲートID</th>
                          <th id="log_gate_gate_name" class="log_gate_gate_name sorting" @click="sort('gateName', 'log_gate_gate_name')" v-bind:class="{'none': checkColumnShowHide('gateName')}">ゲート名</th>
                          <th id="log_gate_device_id" class="log_gate_device_id sorting" @click="sort('deviceId', 'log_gate_device_id')" v-bind:class="{'none': checkColumnShowHide('deviceId')}">照合機器ID</th>
                          <th id="log_gate_device_type" class="center log_gate_device_type sorting" @click="sort('deviceType', 'log_gate_device_type')" v-bind:class="{'none': checkColumnShowHide('deviceType')}">照合機器タイプ</th>
                          <th id="log_gate_log_id" class="center log_gate_log_id sorting" @click="sort('accessLogId', 'log_gate_log_id')" v-bind:class="{'none': checkColumnShowHide('accessLogId')}">ログID</th>
                          <th id="log_gate_label" class="log_gate_label sorting" @click="sort('logLabel', 'log_gate_label')" v-bind:class="{'none': checkColumnShowHide('logLabel')}">ログ名称</th>
                          <th id="log_gate_sequenceNo" class="center log_gate_sequenceNo sorting" @click="sort('sequenceNo', 'log_gate_sequenceNo')" v-bind:class="{'none': checkColumnShowHide('sequenceNo')}">ゲートログNo</th>
                          <th id="log_gate_voltage" class="center log_gate_voltage sorting" @click="sort('voltage', 'log_gate_voltage')" v-bind:class="{'none': checkColumnShowHide('voltage')}">電池電圧</th>
                        </tr>
                      </thead>
                      <tbody v-for="(item, index) in list" :key="index">
                        <tr v-bind:class="{'selected': rowSelectedGateLog(item.accessLogId)}" :id="item.accessLogId">
                          <td class="center" style="display:none">
                            <label class="pos-rel">
                              <input type="checkbox" class="ace" :value="item.accessLogId" v-model="selectedGateLogId">
                              <span class="lbl"></span>
                            </label>
                          </td>
                          <td class="log_gate_time" @click="showdetail">
                            {{ converDate(item.timestamp) }}
                          </td>
                          <td class="log_gate_user_id" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('userId')}">{{item.userId}}</td>
                          <td class="log_gate_user_name" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('userName')}">{{item.userName}}</td>
                          <td class="log_gate_user_furigana" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('userFurigana')}">{{item.userFurigana}}</td>
                          <td class="log_gate_gate_id" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('gateId')}">{{item.gateId}}</td>
                          <td class="log_gate_gate_name" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('gateName')}">{{item.gateName}}</td>
                          <td class="log_gate_device_ud" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('deviceId')}">{{item.deviceId}}</td>
                          <td class="log_gate_device_type" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('deviceType')}">{{item.deviceType}}</td>
                          <td class="center log_gate_log_id" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('accessLogId')}">{{item.accessLogId}}</td>
                          <td class="log_gate_label" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('logLabel')}">{{item.logLabel}}</td>
                          <td class="center log_gate_sequenceNo" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('sequenceNo')}">{{item.sequenceNo}}</td>
                          <td class="center log_gate_voltage" @click="showdetail" v-bind:class="{'none': checkColumnShowHide('voltage')}">{{item.voltage}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
                      <thead>
                        <tr>
                          <th>時間</th>
                          <th>ユーザーID</th>
                          <th>ユーザー名</th>
                          <th>ユーザー名ふりがな</th>
                          <th>ゲートID</th>
                          <th>ゲート名</th>
                          <th>照合機器ID</th>
                          <th>照合機器タイプ</th>
                          <th>ログID</th>
                          <th>ログ名称</th>
                          <th>ゲートログNo</th>
                          <th>電池電圧</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td colspan="12">{{messageLog}}</td></tr>
                      </tbody>
                    </table>
                    <div class="row" v-if="pages>0 && loadPage <= pages">
                      <div class="col-xs-12" style="text-align:center">
                        <button class="btn-cusstom green-btn" type="button" @click="handleCurrentChange(loadPage)">更に読み込む</button>
                      </div>
                    </div>
                    <!--<div class="row" v-if="pages>0">
                      <div class="col-xs-12">
                        <div class="dataTables_paginate paging_simple_numbers">
                          <paginate
                            :page-count="pages"
                            :page-range="3"
                            :margin-pages="2"
                            :click-handler="handleCurrentChange"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                          </paginate>
                        </div>
                      </div>
                    </div>-->
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
              <div id="log-owner" class="tab-pane">
                <div class="page-header">
                  <div class="checkbox">
                    <span style="float:left;padding:5px!important;margin-left:5px">
                      <div class="row">
                      <label class="checkbox-box">
                        <input name="form-field-checkbox" type="checkbox" class="ace" @click="setTimelogOwn()">
                        <span class="lbl">期間指定</span>
                      </label>
                      </div>
                    </span>
                    <div class="col-sm-2">
                      <div class="row">
                        <div class="input-group date-picker">
                          <input class="form-control own-date-picker-notbefore" :disabled="!flaglogOwn" id="own-notBefore" type="text" data-date-format="yyyy/mm/dd" />
                          <span class="input-group-addon own_icon_date_notbefore">
                            <i class="fa fa-calendar bigger-110"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="row">
                        <div class="input-group bootstrap-timepicker">
                          <input id="own-notBefore-time" type="text" :disabled="!flaglogOwn" class="form-control" />
                          <span class="input-group-addon">
                            <i class="fa fa-clock-o bigger-110"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <span style="float:left;padding:5px!important">~</span>
                    <div class="col-sm-2">
                      <div class="row">
                        <div class="input-group date-picker">
                          <input class="form-control own-date-picker-notafter" :disabled="!flaglogOwn" id="own-notAfter" type="text" data-date-format="yyyy/mm/dd" />
                          <span class="input-group-addon own_icon_date_notafter">
                            <i class="fa fa-calendar bigger-110"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="col-sm-2">
                      <div class="row">
                        <div class="input-group bootstrap-timepicker">
                          <input id="own-notAfter-time" type="text" :disabled="!flaglogOwn" class="form-control" />
                          <span class="input-group-addon">
                            <i class="fa fa-clock-o bigger-110"></i>
                          </span>
                        </div>
                      </div>
                    </div>
                    <div style="clear:both"></div>
                  </div>
                  <div class="checkbox">
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox" type="checkbox" checked class="ace own_userId" @click="addRomoveScorpLogOwn('own_userId', 'userId')">
                      <span class="lbl">ユーザーID</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" checked class="ace name" @click="addRomoveScorpLogOwn('name', 'name')">
                      <span class="lbl">ユーザー名</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" checked class="furigana ace" @click="addRomoveScorpLogOwn('furigana', 'furigana')">
                      <span class="lbl">ユーザー名ふりがな</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" checked class="action ace" @click="addRomoveScorpLogOwn('action', 'action')">
                      <span class="lbl">操作内容</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" checked class="targetTable ace" @click="addRomoveScorpLogOwn('targetTable', 'targetTable')">
                      <span class="lbl">操作したテーブル情報</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" checked class="targetRecord ace" @click="addRomoveScorpLogOwn('targetRecord', 'targetRecord')">
                      <span class="lbl">操作したレコード情報</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" checked class="changeSet ace" @click="addRomoveScorpLogOwn('changeSet', 'changeSet')">
                      <span class="lbl">変更内容</span>
                    </label>
                    <label class="checkbox-box">
                      <input name="scorp form-field-checkbox1" type="checkbox" checked class="result ace" @click="addRomoveScorpLogOwn('result', 'result')">
                      <span class="lbl">操作結果</span>
                    </label>
                  </div>
                  <span class="input-icon search-box">
                    <input type="text" placeholder="選択項目にチェックして検索" class="own-nav-search-input" id="own-nav-search-input" autocomplete="off">
                    <i class="ace-icon fa fa-search nav-search-icon"></i>
                  </span>
                  <button class="btn-cusstom green-btn" type="button" @click="searchOwn()">検索</button>
                  <a class="btn-cusstom green-btn export-btn pull-right" href="#processOwn" data-toggle="modal" @click="exportDataExe('ownlogs')">CSVファイルをエクスポート</a>
                  <div style="clear:both"></div>
                  <div class="alert alert-danger" id="error-alert">
                    {{ message }}
                  </div>
                  <div class="alert alert-success" id="success-alert">
                    {{ message }}
                  </div>
                </div><!-- /.page-header -->
                <div class="row">
                  <div class="col-xs-12">
                    <div class="pull-right">
                      <a class="option_button collapsed" data-toggle="collapse" data-parent="#accordion" href="#collapseOne_own" aria-expanded="false">表示オプション&nbsp;
                        <i class="bigger-110 ace-icon fa fa-angle-down" data-icon-hide="ace-icon fa fa-angle-up" data-icon-show="ace-icon fa fa-angle-down"></i>
                      </a>
                    </div>
                    <div class="clearfix" style="clear:both">
                      <div id="accordion">
                        <div class="panel-collapse collapse" id="collapseOne_own" aria-expanded="false" style="height: 0px;">
                          <div class="panel-body">
                            <div class="control-group">
                              <label class="control-label bolder blue display_block">表示項目</label>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_time" type="checkbox" class="ace" disabled checked>
                                  <span class="lbl">時間</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_user_id" type="checkbox" class="ace" @click="ShowHideColumnOwn" checked value="userId" v-model="checkedColumnNamesOwn">
                                  <span class="lbl">ユーザーID</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_user_name" type="checkbox" class="ace" @click="ShowHideColumnOwn" checked value="name" v-model="checkedColumnNamesOwn">
                                  <span class="lbl">ユーザー名</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_user_furigana" type="checkbox" class="ace" @click="ShowHideColumnOwn" checked value="furigana" v-model="checkedColumnNamesOwn">
                                  <span class="lbl">ふりがな</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_action" type="checkbox" class="ace" @click="ShowHideColumnOwn" checked value="action" v-model="checkedColumnNamesOwn">
                                  <span class="lbl">操作内容</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_targettable" type="checkbox" class="ace" @click="ShowHideColumnOwn" checked value="targetTable" v-model="checkedColumnNamesOwn">
                                  <span class="lbl">操作したテーブル情報</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_targetrecord" type="checkbox" class="ace" @click="ShowHideColumnOwn" checked value="targetRecord" v-model="checkedColumnNamesOwn">
                                  <span class="lbl">操作したレコード情報</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_changeSet" type="checkbox" class="ace" @click="ShowHideColumnOwn" checked value="changeSet" v-model="checkedColumnNamesOwn">
                                  <span class="lbl">変更内容</span>
                                </label>
                              </div>
                              <div class="checkbox table_items">
                                <label>
                                  <input name="log_own_result" type="checkbox" class="ace" @click="ShowHideColumnOwn" checked value="result" v-model="checkedColumnNamesOwn">
                                  <span class="lbl">操作結果</span>
                                </label>
                              </div>
                            </div>
                            <div class="control-group">
                              <label class="control-label bolder blue display_block">ページことに表示する項目</label>
                              <select id="pageSizeOptionsOwn" class="first-child last-child" @change="handleSizeChangeOwn" v-model="selectedown">
                                <option v-for="pageSize in pageSizeOptionsown" v-bind:value="pageSize" v-bind:key="pageSize">
                                {{ pageSize }} 件
                                </option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <table id="simple-table-own" class="table  table-bordered table-hover dataTable" v-if="listown.length > 0">
                      <thead>
                        <tr>
                          <th class="center" style="display:none">
                            <label class="pos-rel">
                              <input type="checkbox" class="ace" v-model="selectAllOwnLog">
                              <span class="lbl"></span>
                            </label>
                          </th>
                          <th id="log_own_time" class="log_own_time sorting" @click="sortOwn('timestamp', 'log_own_time')">時間</th>
                          <th id="log_own_user_id" class="log_own_user_id sorting" @click="sortOwn('userId', 'log_own_user_id')" v-bind:class="{'none': checkColumnShowHideOwn('userId')}">ユーザーID</th>
                          <th id="log_own_user_name" class="log_own_user_name sorting" @click="sortOwn('name', 'log_own_user_name')" v-bind:class="{'none': checkColumnShowHideOwn('name')}">ユーザー名</th>
                          <th id="log_own_user_furigana" class="log_own_user_furigana sorting" @click="sortOwn('furigana', 'log_own_user_furigana')" v-bind:class="{'none': checkColumnShowHideOwn('furigana')}">ふりがな</th>
                          <th id="log_own_action" class="log_own_action sorting" @click="sortOwn('action', 'log_own_action')" v-bind:class="{'none': checkColumnShowHideOwn('action')}">操作内容</th>
                          <th id="log_own_targettable" class="log_own_targettable sorting" @click="sortOwn('targetTable', 'log_own_targettable')" v-bind:class="{'none': checkColumnShowHideOwn('targetTable')}">操作したテーブル情報</th>
                          <th class="center log_own_targetrecord" v-bind:class="{'none': checkColumnShowHideOwn('targetRecord')}">操作したレコード情報</th>
                          <th class="center log_own_changeset" v-bind:class="{'none': checkColumnShowHideOwn('changeSet')}">変更内容</th>
                          <th id="log_own_result" class="center log_own_result sorting" @click="sortOwn('result', 'log_own_result')" v-bind:class="{'none': checkColumnShowHideOwn('result')}">操作結果</th>
                        </tr>
                      </thead>
                      <tbody v-for="(item, index) in listown" :key="index">
                        <tr v-bind:class="{'selected': rowSelectedOwnLog(item.logId)}" :id="item.logId">
                          <td class="center" style="display:none">
                            <label class="pos-rel">
                              <input type="checkbox" class="ace" :value="item.logId" v-model="selectedOwnLogId">
                              <span class="lbl"></span>
                            </label>
                          </td>
                          <td class="log_own_time" @click="showdetail">
                            {{ converDate(item.timestamp) }}
                          </td>
                          <td class="log_own_user_id" @click="showdetail" v-bind:class="{'none': checkColumnShowHideOwn('userId')}">{{item.userId}}</td>
                          <td class="log_own_user_name" @click="showdetail" v-bind:class="{'none': checkColumnShowHideOwn('name')}">{{item.name}}</td>
                          <td class="log_own_user_furigana" @click="showdetail" v-bind:class="{'none': checkColumnShowHideOwn('furigana')}">{{item.furigana}}</td>
                          <td class="log_own_action" @click="showdetail" v-bind:class="{'none': checkColumnShowHideOwn('action')}">{{item.action}}</td>
                          <td class="log_own_targettable" @click="showdetail" v-bind:class="{'none': checkColumnShowHideOwn('targetTable')}">{{item.targetTable}}</td>
                          <td class="center log_own_targetrecord" @click="showdetail" v-bind:class="{'none': checkColumnShowHideOwn('targetRecord')}">
                            <span class="changeset-item" v-for="(item, index) in item.targetRecord" :key="index">
                              {{ item.key }}: {{ item.value }}
                            </span>
                          </td>
                          <td class="center log_own_changeset" @click="showdetail" v-bind:class="{'none': checkColumnShowHideOwn('changeSet')}">
                              <span class="changeset-item" v-for="(item, index) in item.changeSet" :key="index">
                                {{ item.key }}: {{ item.value }}
                              </span>
                          </td>
                          <td class="center log_own_result" @click="showdetail" v-bind:class="{'none': checkColumnShowHideOwn('result')}">{{item.result}}</td>
                        </tr>
                      </tbody>
                    </table>
                    <table id="simple-table" class="table  table-bordered table-hover dataTable" v-else>
                      <thead>
                        <tr>
                          <th>時間</th>
                          <th>ユーザーID</th>
                          <th>ユーザー名</th>
                          <th>ユーザー名ふりがな</th>
                          <th>操作内容</th>
                          <th>操作したテーブル情報</th>
                          <th>操作結果</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr><td colspan="7">{{messageOwnLog}}</td></tr>
                      </tbody>
                    </table>
                    <div class="row" v-if="pagesown>0">
                      <div class="col-xs-12">
                        <div class="dataTables_paginate paging_simple_numbers">
                          <paginate
                            :page-count="pagesown"
                            :page-range="3"
                            :margin-pages="2"
                            :click-handler="handleCurrentChangeOwn"
                            :prev-text="'<<'"
                            :next-text="'>>'"
                            :container-class="'pagination'"
                            :page-class="'page-item'">
                          </paginate>
                        </div>
                      </div>
                    </div>
                  </div><!-- /.span -->
                </div><!-- /.row -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- プロフィールModal -->
    <div id="process" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <span class="progress-question">エクスポート進捗状況</span>
            <div class="alert alert-danger">
              CSVダウンロード出力上限数：{{maxExportNumber}}件（総件数：{{totalExportNumber}}件）
            </div>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success}" v-if="pagesLogs>0">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-danger" style="margin:10px 0 0" v-if="errorMessageLogs!==''">
                {{errorMessageLogs}}
              </div>
              <div class="alert alert-danger" style="margin:10px 0 0" v-else>
                該当するデーターがありません。
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success || pagesLogs === 0" @click="resetProcess()">OK</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
    <div id="processOwn" class="modal fade" tabindex="-1">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-body">
            <span class="progress-question">エクスポート進捗状況</span>
            <div class="alert alert-danger">
              CSVダウンロード出力上限数：{{maxExportNumber}}件（総件数：{{exportNumber}}件）
            </div>
            <div class="progress" v-bind:class="{'progress-striped':!success , active:!success}" v-if="pagesOwnLogs>0">
              <div class="progress-bar" :style="progressWidth">
              <span>{{ Math.round(progress) }}%</span>
              </div>
            </div>
            <div v-else>
              <div class="alert alert-danger" style="margin:10px 0 0" v-if="errorMessageLogs!==''">
                {{errorMessageLogs}}
              </div>
              <div class="alert alert-danger" style="margin:10px 0 0" v-else>
                該当するデーターがありません。
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button class="btn btn-sm btn-success pull-right" style="width:100px" data-dismiss="modal" v-if="success || pagesOwnLogs === 0" @click="resetProcess()">OK</button>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal-dialog -->
    </div>
  </div>
</template>

<script>
import * as Config from '../../config'
import moment from 'moment'
import saveAs from 'file-saver/dist/FileSaver'

export default {
  data () {
    return {
      list: [],
      moreData: [],
      mergeData: [],
      columnNames: [
        'userId',
        'userName',
        'userFurigana',
        'gateId',
        'gateName',
        'deviceId',
        'deviceType',
        'accessLogId',
        'logLabel',
        'sequenceNo',
        'voltage'
      ],
      checkedColumnNames: [
        'userId',
        'userName',
        'gateId',
        'gateName',
        'deviceId',
        'logLabel',
        'voltage'
      ],
      checkedColumnNamesOwn: [
        'userId',
        'name',
        'furigana',
        'action',
        'targetTable',
        'targetRecord',
        'changeSet',
        'result'
      ],
      message: '',
      listown: [],
      total: 0,
      totalown: 0,
      selected: 100,
      selectedown: 100,
      scorpLogGate: ['userId', 'userName', 'userFurigana', 'deviceId', 'deviceType', 'gateId', 'gateName', 'logLabel'],
      scorpLogOwn: ['userId', 'name', 'furigana', 'action', 'result', 'targetTable', 'targetRecord', 'changeSet'],
      pages: 0,
      pagesown: 0,
      error: null,
      errorown: null,
      pageSizeOptions: [25, 50, 100, 1000],
      pageSizeOptionsown: [25, 50, 100, 1000],
      listQuery: {
        currPage: 1,
        pageSize: 100
      },
      listQueryown: {
        currPage: 1,
        pageSize: 100
      },
      progress: 0,
      percent: 0,
      percentOwn: 0,
      selectedGateLogId: [],
      selectedOwnLogId: [],
      success: false,
      loading: false,
      isDisabled: false,
      errorMessage: [],
      successPcode: 0,
      errorMessageLogs: '',
      errorMessageOwnLogs: '',
      countGateLOg: 0,
      countOwnLOg: 0,
      flaglogGate: false,
      flaglogOwn: false,
      isAdmin: 'false',
      exportData: [],
      headerData: [],
      logsData: null,
      ownLogsData: null,
      pagesLogs: 0,
      logsDataLoad: 0,
      pagesOwnLogs: 0,
      ownLogsDataLoad: 0,
      loadAllPageData: 0,
      isVisible: true,
      isVisibleOwn: true,
      messageOwnLog: 'データー取得中',
      messageLog: 'データー取得中',
      maxExportNumber: 10000,
      exportNumber: 0,
      loadPage: 2,
      totalExportNumber: 0
    }
  },
  watch: {
    'progress': 'checkProgress',
    'checkedColumnNames': 'updateChecked',
    'checkedColumnNamesOwn': 'updateCheckedOwn',
    logsDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesLogs) {
        this.isVisible = false
        this.downloadCSV('logs')
        this.reset()
      } else if (newVal > 0) {
        this.getDataForLogs(newVal + 1)
      }
    },
    ownLogsDataLoad: function (newVal, oldVal) {
      if (newVal === this.pagesOwnLogs) {
        this.isVisibleOwn = false
        this.downloadCSV('ownlogs')
        this.reset()
      } else if (newVal > 0) {
        this.getDataForOwnLogs(newVal + 1)
      }
    }
  },
  computed: {
    progressWidth: function () {
      return 'width:' + this.progress + '%'
    },
    selectAllGateLog: {
      get: function () {
        return this.list ? this.selectedGateLogId.length === this.list.length : false
      },
      set: function (value) {
        var selectedGateLogId = []
        if (value) {
          this.list.forEach(function (item) {
            selectedGateLogId.push(item.accessLogId)
          })
        }
        this.selectedGateLogId = selectedGateLogId
      }
    },
    selectAllOwnLog: {
      get: function () {
        return this.listown ? this.selectedOwnLogId.length === this.listown.length : false
      },
      set: function (value) {
        var selectedOwnLogId = []
        if (value) {
          this.listown.forEach(function (item) {
            selectedOwnLogId.push(item.logId)
          })
        }
        this.selectedOwnLogId = selectedOwnLogId
      }
    }
  },
  mounted () {
    var vm = this
    vm.isAdmin = localStorage.isAdmin
    $('#nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.search()
      }
    })
    $('#own-nav-search-input').keyup(function (e) {
      if (e.keyCode === 13) {
        vm.searchOwn()
      }
    })
    if (typeof localStorage.pageSizeLogGate === 'undefined') {
      localStorage.setItem('pageSizeLogGate', 100)
      this.selected = localStorage.pageSizeLogGate
    } else {
      this.selected = localStorage.pageSizeLogGate
    }
    if (typeof localStorage.pageSizeLogOwner === 'undefined') {
      localStorage.setItem('pageSizeLogOwner', 100)
      this.selectedown = localStorage.pageSizeLogOwner
    } else {
      this.selectedown = localStorage.pageSizeLogOwner
    }
    if (typeof localStorage.logGateSortKey === 'undefined') {
      localStorage.setItem('logGateSortKey', 'timestamp')
    }
    if (typeof localStorage.logGateSortName === 'undefined') {
      localStorage.setItem('logGateSortName', 'desc')
    }
    if (typeof localStorage.logOwnSortKey === 'undefined') {
      localStorage.setItem('logOwnSortKey', 'timestamp')
    }
    if (typeof localStorage.logOwnSortName === 'undefined') {
      localStorage.setItem('logOwnSortName', 'desc')
    }
    if (typeof localStorage.checkedLog === 'undefined') {
      localStorage.setItem('checkedLog', this.checkedColumnNames)
    } else {
      var tempData = []
      this.columnNames.forEach(function (item) {
        if (localStorage.checkedLog.indexOf(item) !== -1) {
          tempData.push(item)
        }
      })
      this.checkedColumnNames = tempData
    }
    if (typeof localStorage.checkedLogOwn === 'undefined') {
      localStorage.setItem('checkedLogOwn', this.checkedColumnNamesOwn)
    } else {
      var tempDataOwn = []
      this.checkedColumnNamesOwn.forEach(function (item) {
        if (localStorage.checkedLogOwn.indexOf(item) !== -1) {
          tempDataOwn.push(item)
        }
      })
      this.checkedColumnNamesOwn = tempDataOwn
    }
    this.getList()
    // 照合ログ
    $('.date-picker-notbefore').datepicker({
      language: 'ja',
      autoclose: true,
      todayHighlight: true
    })
    $('.date-picker-notafter').datepicker({
      language: 'ja',
      autoclose: true,
      todayHighlight: true
    })
    $('.date-picker-notbefore').datepicker().datepicker('setDate', new Date())
    $('.date-picker-notafter').datepicker().datepicker('setDate', new Date())
    $('.icon_date_notbefore').click(function () {
      $('.date-picker-notbefore').focus()
    })
    $('.icon_date_notafter').click(function () {
      $('.date-picker-notafter').focus()
    })
    $('#notBefore-time').timepicker({
      minuteStep: 1,
      showSeconds: true,
      showMeridian: false,
      disableFocus: true,
      icons: {
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down'
      }
    }).on('focus', function () {
      $('#notBefore-time').timepicker('showWidget')
    })
    $('#notAfter-time').timepicker({
      minuteStep: 1,
      showSeconds: true,
      showMeridian: false,
      disableFocus: true,
      icons: {
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down'
      }
    }).on('focus', function () {
      $('#notAfter-time').timepicker('showWidget')
    })
    // 操作ログ
    $('.own-date-picker-notbefore').datepicker({
      language: 'ja',
      autoclose: true,
      todayHighlight: true
    })
    $('.own-date-picker-notafter').datepicker({
      language: 'ja',
      autoclose: true,
      todayHighlight: true
    })
    $('.own-date-picker-notbefore').datepicker().datepicker('setDate', new Date())
    $('.own-date-picker-notafter').datepicker().datepicker('setDate', new Date())
    $('.own_icon_date_notbefore').click(function () {
      $('.own-date-picker-notbefore').focus()
    })
    $('.own_icon_date_notafter').click(function () {
      $('.own-date-picker-notafter').focus()
    })
    $('#own-notBefore-time').timepicker({
      minuteStep: 1,
      showSeconds: true,
      showMeridian: false,
      disableFocus: true,
      icons: {
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down'
      }
    }).on('focus', function () {
      $('#own-notBefore-time').timepicker('showWidget')
    })
    $('#own-notAfter-time').timepicker({
      minuteStep: 1,
      showSeconds: true,
      showMeridian: false,
      disableFocus: true,
      icons: {
        up: 'fa fa-chevron-up',
        down: 'fa fa-chevron-down'
      }
    }).on('focus', function () {
      $('#own-notAfter-time').timepicker('showWidget')
    })
  },
  methods: {
    loadLog () {
      this.errorMessageLogs = ''
      this.exportNumber = 0
      if (this.list === null) {
        this.getList()
      }
    },
    loadOwnLog () {
      this.errorMessageLogs = ''
      this.exportNumber = 0
      if (this.listown === null) {
        this.getListOwn()
      }
    },
    // 実行状態チェック
    checkProgress () {
      this.exportNumber = this.exportData.length
      if (Math.round(this.progress) === 100) {
        this.success = true
      }
    },
    converToDateLog (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm:ss')
    },
    getDataForLogs (page) {
      var vm = this
      if (this.scorpLogGate.length > 0) {
        var notBefore = 0
        var notAfter = this.converTimestamp('10000/01/01')
        if (this.flaglogGate) {
          var notBeforeDate = $('#notBefore').val() + ' ' + $('#notBefore-time').val()
          var notAfterDate = $('#notAfter').val() + ' ' + $('#notAfter-time').val()
          notBefore = this.converTimestamp(notBeforeDate)
          notAfter = this.converTimestamp(notAfterDate)
        }
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.LOG_GATE_LIST_API + '?limit=1000&page=' + page + '&keyword=' + keyword + '&scorp=' + this.scorpLogGate + '&sortKey=' + localStorage.logGateSortName + ':' + localStorage.logGateSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
          .then(response => {
            console.log(response)
            vm.logsDataLoad++
            this.logsData = response.body.logs
            this.logsData.forEach(function (item) {
              if (vm.exportData.length < vm.maxExportNumber) {
                vm.exportData.push({
                  [vm.headerData[0]]: vm.converToDateLog(item.timestamp),
                  [vm.headerData[1]]: item.userId,
                  [vm.headerData[2]]: item.userName,
                  [vm.headerData[3]]: item.userFurigana,
                  [vm.headerData[4]]: item.gateId,
                  [vm.headerData[5]]: item.gateName,
                  [vm.headerData[6]]: item.deviceId,
                  [vm.headerData[7]]: item.deviceType,
                  [vm.headerData[8]]: item.accessLogId,
                  [vm.headerData[9]]: item.logLabel,
                  [vm.headerData[10]]: item.sequenceNo,
                  [vm.headerData[11]]: item.voltage
                })
                vm.progress += vm.percent
              }
            })
          })
          .catch(error => {
            console.log(error)
            vm.progress += vm.percent
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
      }
    },
    getDataForOwnLogs (page) {
      var vm = this
      if (this.scorpLogOwn.length > 0) {
        var notBefore = 0
        var notAfter = this.converTimestamp('10000/01/01')
        if (this.flaglogOwn) {
          var notBeforeDate = $('#own-notBefore').val() + ' ' + $('#own-notBefore-time').val()
          var notAfterDate = $('#own-notAfter').val() + ' ' + $('#own-notAfter-time').val()
          notBefore = this.converTimestamp(notBeforeDate)
          notAfter = this.converTimestamp(notAfterDate)
        }
        var keyword = $('.own-nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.LOG_OWNER_LIST_API + '?limit=1000&page=' + page + '&keyword=' + keyword + '&scorp=' + this.scorpLogOwn + '&sortKey=' + localStorage.logOwnSortName + ':' + localStorage.logOwnSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
          .then(response => {
            console.log(response)
            this.ownLogsData = response.body.logs
            this.ownLogsData.forEach(function (item) {
              var dataTargetRecord = ''
              var dataChangeSet = ''
              if (item.targetRecord.length > 0) {
                item.targetRecord.forEach(function (itemTargetRecord) {
                  dataTargetRecord += itemTargetRecord.key + ':' + itemTargetRecord.value + ';'
                })
              }
              if (item.changeSet.length > 0) {
                item.changeSet.forEach(function (itemChangeSet) {
                  dataChangeSet += itemChangeSet.key + ':' + itemChangeSet.value + ';'
                })
              }
              if (vm.exportData.length < vm.maxExportNumber) {
                vm.exportData.push({
                  [vm.headerData[0]]: vm.converToDateLog(item.timestamp),
                  [vm.headerData[1]]: item.userId,
                  [vm.headerData[2]]: item.name,
                  [vm.headerData[3]]: item.furigana,
                  [vm.headerData[4]]: item.action,
                  [vm.headerData[5]]: item.targetTable,
                  [vm.headerData[6]]: dataTargetRecord,
                  [vm.headerData[7]]: dataChangeSet,
                  [vm.headerData[8]]: item.result
                })
                vm.progress += vm.percentOwn
              }
            })
            vm.ownLogsDataLoad++
          })
          .catch(error => {
            vm.progress += vm.percentOwn
            console.log(error)
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
      }
    },
    exportDataExe (tablename) {
      var vm = this
      vm.isVisible = true
      vm.isVisibleOwn = true
      switch (tablename) {
        case 'logs':
          vm.pagesLogs = 1
          vm.readTextFile('../../../static/headertxt/logs.txt')
          vm.searchNoShowData()
          break
        case 'ownlogs':
          vm.pagesOwnLogs = 1
          vm.readTextFile('../../../static/headertxt/ownlogs.txt')
          vm.searchOwnNoShowData()
          break
        default:
          vm.pagesLogs = 1
          vm.readTextFile('../../../static/headertxt/logs.txt')
          vm.searchNoShowData()
          break
      }
    },
    convertArrayOfObjectsToCSV (args) {
      var result, ctr, keys, columnDelimiter, lineDelimiter, data
      data = args.data || null
      if (data == null || !data.length) {
        return null
      }
      columnDelimiter = args.columnDelimiter || ','
      lineDelimiter = args.lineDelimiter || '\n'
      keys = Object.keys(data[0])
      result = ''
      result += keys.join(columnDelimiter)
      result += lineDelimiter
      data.forEach(function (item) {
        ctr = 0
        keys.forEach(function (key) {
          if (ctr > 0) result += columnDelimiter
          result += item[key]
          ctr++
        })
        result += lineDelimiter
      })
      return result
    },
    downloadCSV (tablename) {
      var vm = this
      var filename
      var csv = this.convertArrayOfObjectsToCSV({
        data: vm.exportData
      })
      filename = tablename + '-data.csv' || 'export.csv'
      var bom = new Uint8Array([0xEF, 0xBB, 0xBF])
      var blob = new Blob([ bom, csv ], {type: 'text/csv;charset=utf-8;'})
      // ダウンロード実行
      var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)
      if (isSafari) {
        saveAs(blob, filename)
      } else {
        if (window.navigator.msSaveOrOpenBlob) {
          // IEの場合
          navigator.msSaveBlob(blob, filename)
        } else {
          // IE以外(Chrome, Firefox)
          var downloadLink = $('<a></a>')
          downloadLink.attr('href', window.URL.createObjectURL(blob))
          downloadLink.attr('download', filename)
          downloadLink.attr('target', '_blank')
          $('body').append(downloadLink)
          downloadLink[0].click()
          downloadLink.remove()
        }
      }
    },
    readTextFile (file) {
      var vm = this
      var rawFile = new XMLHttpRequest()
      rawFile.open('GET', file, false)
      rawFile.onreadystatechange = function () {
        if (rawFile.readyState === 4) {
          if (rawFile.status === 200 || rawFile.status === 0) {
            vm.headerData = rawFile.responseText.split('\n')
          } else {
            vm.message = 'HEADERのデーターはありません。'
            $('#error-alert').fadeTo(2000, 500).slideUp(500, function () {
              $('#error-alert').slideUp(500)
            })
          }
        }
      }
      rawFile.send(null)
    },
    resetProcess () {
      this.progress = 0
      this.success = false
      this.isVisible = false
      this.isVisibleOwn = false
      this.logsDataLoad = 0
      this.ownLogsDataLoad = 0
      this.exportNumber = 0
    },
    reset () {
      this.exportData = []
      this.headerData = []
      this.logsDataLoad = 0
      this.ownLogsDataLoad = 0
    },
    updateChecked () {
      localStorage.setItem('checkedLog', this.checkedColumnNames)
    },
    checkColumnShowHide (columnName) {
      if (localStorage.checkedLog.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    updateCheckedOwn () {
      localStorage.setItem('checkedLogOwn', this.checkedColumnNamesOwn)
    },
    checkColumnShowHideOwn (columnName) {
      if (localStorage.checkedLogOwn.indexOf(columnName) !== -1) {
        return false
      } else {
        return true
      }
    },
    renderKey (logId) {
      return Math.random() + logId
    },
    setTimelogGate () {
      if (this.flaglogGate) {
        this.flaglogGate = false
      } else {
        this.flaglogGate = true
      }
    },
    setTimelogOwn () {
      if (this.flaglogOwn) {
        this.flaglogOwn = false
      } else {
        this.flaglogOwn = true
      }
    },
    // 行にチェックする (照合ログ)
    rowSelectedGateLog (accessLogId) {
      if (jQuery.inArray(accessLogId, this.selectedGateLogId) !== -1) {
        return true
      } else {
        return false
      }
    },
    // 行にチェックする (操作ログ)
    rowSelectedOwnLog (logId) {
      if (jQuery.inArray(logId, this.selectedOwnLogId) !== -1) {
        return true
      } else {
        return false
      }
    },
    handleSizeChange () {
      this.listQuery.pageSize = $('#pageSizeOptions').val()
      localStorage.setItem('pageSizeLogGate', this.listQuery.pageSize)
      this.listQuery.currPage = 1
      this.pages = 0
      this.loadPage = 2
      this.getList()
    },
    handleSizeChangeOwn () {
      this.listQueryown.pageSize = $('#pageSizeOptionsOwn').val()
      localStorage.setItem('pageSizeLogOwner', this.listQueryown.pageSize)
      this.listQueryown.currPage = 1
      this.pagesown = 0
      this.getListOwn()
    },
    handleCurrentChange (val) {
      this.listQuery.currPage = val
      this.loadMoreData()
    },
    handleCurrentChangeOwn (val) {
      this.listQueryown.currPage = val
      this.getListOwn()
      window.scrollTo(0, 0)
    },
    randomImageId (idname) {
      return 'image' + idname
    },
    randomDynamicTable (classname) {
      return 'dynamic-table' + classname
    },
    converDate (t) {
      return moment(new Date(t * 1000)).format('YYYY/MM/DD HH:mm:ss')
    },
    converTimestamp (t) {
      return parseInt(new Date(t) / 1000)
    },
    showAvatar (imgdata) {
      return 'data:image/png;base64,' + imgdata
    },
    ShowHideColumn: function (e) {
      var $tbl = $('#simple-table')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    ShowHideColumnOwn: function (e) {
      var $tbl = $('#simple-table-own')
      var colToHide = $tbl.find('.' + $(e.target).attr('name'))
      $(colToHide).toggle()
    },
    showdetail: function (e) {
      e.preventDefault()
      $(e.target).closest('tr').next().toggleClass('open')
    },
    // 検索項目チェンジ
    addRomoveScorpLogGate (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorpLogGate.push(scorpname)
      } else {
        this.scorpLogGate.splice($.inArray(scorpname, this.scorpLogGate), 1)
      }
    },
    // 検索
    search () {
      var vm = this
      this.errorMessageLogs = ''
      this.loading = true
      if (this.scorpLogGate.length > 0) {
        window.scrollTo(0, 0)
        this.listQuery.currPage = 1
        this.pages = 0
        this.loadPage = 2
        var notBefore = 0
        var notAfter = this.converTimestamp('10000/01/01')
        if (this.flaglogGate) {
          var notBeforeDate = $('#notBefore').val() + ' ' + $('#notBefore-time').val()
          var notAfterDate = $('#notAfter').val() + ' ' + $('#notAfter-time').val()
          notBefore = this.converTimestamp(notBeforeDate)
          notAfter = this.converTimestamp(notAfterDate)
        }
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.LOG_GATE_LIST_API + '?limit=' + localStorage.pageSizeLogGate + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorpLogGate + '&sortKey=' + localStorage.logGateSortName + ':' + localStorage.logGateSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
          .then(response => {
            this.loading = false
            if (response.body.maxRecords > 0) {
              this.totalExportNumber = response.body.maxRecords
              if (response.body.maxRecords < vm.maxExportNumber) {
                vm.percent = (100 / (response.body.maxRecords))
                vm.pagesLogs = Math.ceil((response.body.maxRecords) / localStorage.pageSizeLogGate)
              } else {
                vm.percent = (100 / (vm.maxExportNumber))
                vm.pagesLogs = Math.ceil((vm.maxExportNumber) / localStorage.pageSizeLogGate)
              }
              this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeLogGate)
              this.list = response.body.logs
              console.log(this.pages)
            } else {
              this.totalExportNumber = 0
              this.list = []
              this.pages = 0
              this.pagesLogs = 0
              this.messageLog = '該当するデーターがありません。'
            }
            console.log(response)
          })
          .catch((error) => {
            this.list = []
            this.loading = false
            this.pages = 0
            this.pagesLogs = 0
            switch (error.status) {
              case 400:
                vm.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                vm.errorMessageLogs = '照合ログの取得権限がありません。'
                break
              case 500:
                vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
            this.messageLog = '該当するデーターがありません。'
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    searchNoShowData () {
      var vm = this
      vm.errorMessageLogs = ''
      if (this.scorpLogGate.length > 0) {
        var notBefore = 0
        var notAfter = this.converTimestamp('10000/01/01')
        if (this.flaglogGate) {
          var notBeforeDate = $('#notBefore').val() + ' ' + $('#notBefore-time').val()
          var notAfterDate = $('#notAfter').val() + ' ' + $('#notAfter-time').val()
          notBefore = this.converTimestamp(notBeforeDate)
          notAfter = this.converTimestamp(notAfterDate)
        }
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.LOG_GATE_LIST_API + '?limit=1000&page=1&keyword=' + keyword + '&scorp=' + this.scorpLogGate + '&sortKey=' + localStorage.logGateSortName + ':' + localStorage.logGateSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
          .then(response => {
            if (response.body.maxRecords > 0) {
              if (response.body.maxRecords < vm.maxExportNumber) {
                vm.percent = (100 / (response.body.maxRecords))
                vm.pagesLogs = Math.ceil((response.body.maxRecords) / 1000)
                console.log(vm.pagesLogs)
                vm.getDataForLogs(1)
              } else {
                vm.percent = (100 / (vm.maxExportNumber))
                vm.pagesLogs = Math.ceil((vm.maxExportNumber) / 1000)
                console.log(vm.pagesLogs)
                vm.getDataForLogs(1)
              }
            } else {
              vm.percent = 100
              this.pagesLogs = 0
              console.log(vm.pagesLogs)
            }
            console.log(response)
          })
          .catch((error) => {
            this.pagesLogs = 0
            switch (error.status) {
              case 400:
                vm.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
              case 500:
                vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        this.pagesLogs = 0
      }
    },
    // ソート
    sort (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('logGateSortName', 'desc')
        localStorage.setItem('logGateSortKey', sortkey)
      } else {
        $('#simple-table>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('logGateSortName', 'asc')
        localStorage.setItem('logGateSortKey', sortkey)
      }
      this.getList()
    },
    getList () {
      this.loading = true
      this.errorMessageLogs = ''
      var notBefore = 0
      var notAfter = this.converTimestamp('10000/01/01')
      if (this.flaglogGate) {
        var notBeforeDate = $('#notBefore').val() + ' ' + $('#notBefore-time').val()
        var notAfterDate = $('#notAfter').val() + ' ' + $('#notAfter-time').val()
        notBefore = this.converTimestamp(notBeforeDate)
        notAfter = this.converTimestamp(notAfterDate)
      }
      if (this.list.length > 0) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      this.$http.get(Config.LOG_GATE_LIST_API + '?limit=' + localStorage.pageSizeLogGate + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorpLogGate + '&sortKey=' + localStorage.logGateSortName + ':' + localStorage.logGateSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
        .then(response => {
          if (response.body.maxRecords > 0) {
            this.totalExportNumber = response.body.maxRecords
            this.loading = false
            console.log(response)
            this.pages = Math.ceil((response.body.maxRecords) / localStorage.pageSizeLogGate)
            this.list = response.body.logs
            console.log(this.list)
          } else {
            this.totalExportNumber = 0
            this.loading = false
            this.list = []
            this.pages = 0
            this.messageLog = '該当するデーターがありません。'
          }
        })
        .catch((error) => {
          var vm = this
          this.list = []
          this.loading = false
          this.pages = 0
          switch (error.status) {
            case 400:
              vm.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              vm.errorMessageLogs = '照合ログの取得権限がありません。'
              break
            case 500:
              vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
          this.messageLog = '該当するデーターがありません。'
        })
    },
    loadMoreData () {
      this.loading = true
      var notBefore = 0
      var notAfter = this.converTimestamp('10000/01/01')
      if (this.flaglogGate) {
        var notBeforeDate = $('#notBefore').val() + ' ' + $('#notBefore-time').val()
        var notAfterDate = $('#notAfter').val() + ' ' + $('#notAfter-time').val()
        notBefore = this.converTimestamp(notBeforeDate)
        notAfter = this.converTimestamp(notAfterDate)
      }
      if (this.list !== null) {
        var keyword = $('.nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      this.$http.get(Config.LOG_GATE_LIST_API + '?limit=' + localStorage.pageSizeLogGate + '&page=' + this.listQuery.currPage + '&keyword=' + keyword + '&scorp=' + this.scorpLogGate + '&sortKey=' + localStorage.logGateSortName + ':' + localStorage.logGateSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
        .then(response => {
          console.log(response)
          if (response.body.maxRecords > 0) {
            this.loading = false
            this.moreData = response.body.logs
            console.log(this.moreData)
            this.mergeData = this.list.concat(this.moreData)
            this.list = this.mergeData
            this.loadPage++
          } else {
            this.loading = false
          }
        })
        .catch((error) => {
          var vm = this
          this.list = []
          this.loading = false
          this.pages = 0
          switch (error.status) {
            case 400:
              vm.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              vm.errorMessageLogs = '照合ログの取得権限がありません。'
              break
            case 500:
              vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
          this.messageLog = '該当するデーターがありません。'
        })
    },
    // ソート(操作ログ)
    sortOwn (sortkey, elementname) {
      this.loading = true
      if ($('#' + elementname).hasClass('sorting_asc')) {
        $('#simple-table-own>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table-own>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_asc')
        $('#' + elementname).addClass('sorting_desc')
        localStorage.setItem('logOwnSortName', 'desc')
        localStorage.setItem('logOwnSortKey', sortkey)
      } else {
        $('#simple-table-own>thead>tr>th').removeClass('sorting_asc')
        $('#simple-table-own>thead>tr>th').removeClass('sorting_desc')
        $('#' + elementname).removeClass('sorting_desc')
        $('#' + elementname).addClass('sorting_asc')
        localStorage.setItem('logOwnSortName', 'asc')
        localStorage.setItem('logOwnSortKey', sortkey)
      }
      this.getListOwn()
    },
    // 検索項目チェンジ(操作ログ)
    addRomoveScorpLogOwn (classname, scorpname) {
      if ($('.' + classname).prop('checked')) {
        this.scorpLogOwn.push(scorpname)
      } else {
        this.scorpLogOwn.splice($.inArray(scorpname, this.scorpLogOwn), 1)
      }
    },
    // 検索 (操作ログ)
    searchOwn () {
      var vm = this
      vm.errorMessageLogs = ''
      this.loading = true
      this.isVisibleOwn = false
      if (this.scorpLogOwn.length > 0) {
        window.scrollTo(0, 0)
        this.listQueryown.currPage = 1
        this.pagesown = 0
        var notBefore = 0
        var notAfter = this.converTimestamp('10000/01/01')
        if (this.flaglogOwn) {
          var notBeforeDate = $('#own-notBefore').val() + ' ' + $('#own-notBefore-time').val()
          var notAfterDate = $('#own-notAfter').val() + ' ' + $('#own-notAfter-time').val()
          notBefore = this.converTimestamp(notBeforeDate)
          notAfter = this.converTimestamp(notAfterDate)
        }
        var keyword = $('.own-nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.LOG_OWNER_LIST_API + '?limit=' + localStorage.pageSizeLogOwner + '&page=' + this.listQueryown.currPage + '&keyword=' + keyword + '&scorp=' + this.scorpLogOwn + '&sortKey=' + localStorage.logOwnSortName + ':' + localStorage.logOwnSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
          .then(response => {
            this.loading = false
            if (response.body.maxRecords > 0) {
              if (response.body.maxRecords < vm.maxExportNumber) {
                vm.percentOwn = (100 / (response.body.maxRecords))
                vm.pagesOwnLogs = Math.ceil((response.body.maxRecords) / localStorage.pageSizeLogOwner)
              } else {
                vm.percentOwn = (100 / (vm.maxExportNumber))
                vm.pagesOwnLogs = Math.ceil((vm.maxExportNumber) / localStorage.pageSizeLogOwner)
              }
              this.pagesown = Math.ceil((response.body.maxRecords) / localStorage.pageSizeLogOwner)
              this.listown = response.body.logs
            } else {
              this.listown = []
              this.pagesown = 0
              this.pagesOwnLogs = 0
              this.messageOwnLog = '該当するデーターがありません。'
            }
            console.log(response)
          })
          .catch((error) => {
            this.listown = []
            this.loading = false
            this.pagesown = 0
            this.pagesOwnLogs = 0
            this.messageOwnLog = '該当するデーターがありません。'
            switch (error.status) {
              case 400:
                vm.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                vm.errorMessageLogs = '操作ログの取得権限がありません。'
                break
              case 500:
                vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        alert('少なくても検索項目を１つ選んでください。')
        this.loading = false
      }
    },
    searchOwnNoShowData () {
      var vm = this
      vm.errorMessageLogs = ''
      this.isVisibleOwn = false
      if (this.scorpLogOwn.length > 0) {
        var notBefore = 0
        var notAfter = this.converTimestamp('10000/01/01')
        if (this.flaglogOwn) {
          var notBeforeDate = $('#own-notBefore').val() + ' ' + $('#own-notBefore-time').val()
          var notAfterDate = $('#own-notAfter').val() + ' ' + $('#own-notAfter-time').val()
          notBefore = this.converTimestamp(notBeforeDate)
          notAfter = this.converTimestamp(notAfterDate)
        }
        var keyword = $('.own-nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
        this.$http.get(Config.LOG_OWNER_LIST_API + '?limit=1000&page=1&keyword=' + keyword + '&scorp=' + this.scorpLogOwn + '&sortKey=' + localStorage.logOwnSortName + ':' + localStorage.logOwnSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
          .then(response => {
            this.loading = false
            if (response.body.maxRecords > 0) {
              if (response.body.maxRecords < vm.maxExportNumber) {
                vm.percentOwn = (100 / (response.body.maxRecords))
                vm.pagesOwnLogs = Math.ceil((response.body.maxRecords) / 1000)
                console.log(vm.pagesOwnLogs)
                vm.getDataForOwnLogs(1)
              } else {
                vm.percentOwn = (100 / (vm.maxExportNumber))
                vm.pagesOwnLogs = Math.ceil((vm.maxExportNumber) / 1000)
                console.log(vm.pagesOwnLogs)
                vm.getDataForOwnLogs(1)
              }
            } else {
              this.pagesOwnLogs = 0
              console.log(vm.pagesOwnLogs)
            }
          })
          .catch((error) => {
            this.pagesOwnLogs = 0
            switch (error.status) {
              case 400:
                vm.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
                break
              case 403:
                vm.errorMessageLogs = '操作ログの取得権限がありません。'
                break
              case 500:
                vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              case 503:
                vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
                break
              default:
                vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
                break
            }
          })
      } else {
        this.pagesOwnLogs = 0
      }
    },
    getListOwn () {
      this.loading = true
      var vm = this
      this.errorMessageLogs = ''
      var notBefore = 0
      var notAfter = this.converTimestamp('10000/01/01')
      if (this.flaglogOwn) {
        var notBeforeDate = $('#own-notBefore').val() + ' ' + $('#own-notBefore-time').val()
        var notAfterDate = $('#own-notAfter').val() + ' ' + $('#own-notAfter-time').val()
        notBefore = this.converTimestamp(notBeforeDate)
        notAfter = this.converTimestamp(notAfterDate)
      }
      if (this.listown !== null) {
        var keyword = $('.own-nav-search-input').val()
        keyword = keyword.replace(/\s/g, ',')
        keyword = encodeURIComponent(keyword)
      } else {
        keyword = ''
      }
      this.$http.get(Config.LOG_OWNER_LIST_API + '?limit=' + localStorage.pageSizeLogOwner + '&page=' + this.listQueryown.currPage + '&keyword=' + keyword + '&scorp=' + this.scorpLogOwn + '&sortKey=' + localStorage.logOwnSortName + ':' + localStorage.logOwnSortKey + '&notBefore=' + notBefore + '&notAfter=' + notAfter)
        .then(response => {
          this.loading = false
          if (response.body.maxRecords > 0) {
            this.listown = response.body.logs
            this.pagesown = Math.ceil((response.body.maxRecords) / localStorage.pageSizeLogOwner)
          } else {
            this.loading = false
            this.listown = []
            this.pagesown = 0
            this.messageOwnLog = '該当するデーターがありません。'
          }
          console.log(response)
        })
        .catch((error) => {
          this.listown = []
          this.loading = false
          this.pagesown = 0
          this.messageOwnLog = '該当するデーターがありません。'
          switch (error.status) {
            case 400:
              vm.errorMessageLogs = '入力したパラメーターが誤っています。入力内容をご確認ください。'
              break
            case 403:
              vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
            case 500:
              vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            case 503:
              vm.errorMessageLogs = 'サーバーから応答がありませんでした。しばらく経ってからやり直してください。'
              break
            default:
              vm.errorMessageLogs = 'アクセス情報が不正です。ログインし直してからやり直してください。'
              break
          }
        })
    }
  }
}
</script>

<style>
.bootstrap-timepicker-widget table td input {
  width: 35px;
}
.checkbox label, .radio label {
  padding-left: 10px!important
}
.checkbox-box{
  margin-right: 15px
}
.edit-bottom,.delete-bottom{
  width: 100%;
  margin-bottom: 15px
}
.fa-6{
  font-size: 3em;
}
.fa-3{
  font-size: 2em;
}
.table>tbody>tr>td{
  vertical-align: middle;
  padding: 5px;
  font-size: 16px;
}
.dataTables_paginate .pagination {
  margin: 0;
}
.table-bordered>tbody>tr>td{
  border-right:3px solid #fff;
}
.label-sm {
  padding: 10px;
  font-size: 16px;
  line-height: 1;
  height: auto;
}
#simple-table .profile-info-name{
  width: 255px
}
.device{
  margin-top: 50px;
  border-top: 2px solid #ccc
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle.collapsed{
  font-size: 18px
}
.table-detail .accordion-style1.panel-group .panel-heading .accordion-toggle{
  font-size: 18px
}
.add-buttom{
  margin-bottom: 10px
}
.modal-content .form-horizontal .control-label{
  text-align: left;
}
.chosen-container-single .chosen-single{
  border-radius: 0px;
  height: 35px;
  font-size: 16px;
  line-height: 35px!important;
}
.chosen-container-single{
  width: 100%!important
}
.chosen-container{
  margin-bottom: 10px
}
.dataTable>thead>tr>th[class*=sorting_]{
  color: #707070
}
#collapseOne_own {
    border: 1px solid #ccc;
}
.export-btn[disabled]{
  background: #ccc!important;
  border: 1px solid #ccc!important;
}
a.export-btn:hover, a.export-btn:active, a.export-btn:focus, a.export-btn:focus:active, a.export-btn:focus:hover{
  color:#fff!important;
  text-decoration: none!important;
}
</style>



// WEBPACK FOOTER //
// src/views/log/LogList.vue